import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class VideoV4 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    return (
      <div
        className="ltn__slider-area ltn__slider-4 position-relative ltn__primary-bg"
        style={{ overflow: "hidden" }}
      >
        <div className="ltn__slide-one-active----- slick-slide-arrow-1----- slick-slide-dots-1----- arrow-white----- ltn__slide-animation-active">
          {/* HTML5 VIDEO */}
          <video style={{ opacity: 0.5 }} autoPlay muted loop id="myVideo">
            <source src={publicUrl + "assets/media/4.mp4"} type="video/mp4" />
          </video>
          <div
            className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-7 bg-image--- bg-overlay-theme-black-10---"
            data-bs-bg="img/slider/41.jpg"
          >
            <div className="ltn__slide-item-inner text-center">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 align-self-center">
                    <div className="slide-item-info">
                      <div className="slide-item-info-inner ltn__slide-animation">
                        {/* <h6 className="slide-sub-title white-color animated"><span><i className="fas fa-home" /></span> MEDESCO, l’immobilier réinventé pour vous. - Projet Diamantine</h6> */}
                        <img
                          className="mb-3"
                          src={publicUrl + "assets/img/logo.svg"}
                          alt="Logo"
                          width="40%"
                        />
                        <h1 className="slide-title text-uppercase white-color animated ">
                          L’immobilier réinventé pour vous
                        </h1>
                        <p className="white-color animated">
                          Offrez-vous le confort que vous méritez!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VideoV4;
